import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FcDepartment } from "react-icons/fc";
import { HiCheck, HiOutlineClipboardDocumentCheck, HiOutlineShieldCheck } from "react-icons/hi2";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

import cf from "../UI/ClassicForm.module.css";
import useInput from "../../hooks/userInput";
import { createTransaction } from "../../api/api";
import { alertActions } from "../../store/alert-slice";
import Spinner from "../UI/Spinner";
import { formatCurrency } from "../../util/utility";
import { currencySymbol } from "../../util/config";

const ConfirmLocal = () => {
  const transaction = useSelector((state) => state.transfer.transactions);
  const [showSpinner, setShowSpinner] = useState(false);
  const { jwt } = useCookies(["jwt"])[0];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    value: tokenInput,
    enteredValueIsValid: tokenInputIsValid,
    hasError: tokenInputIsInvalid,
    valueInputChangedHandler: tokenInputChangedHandler,
    valueInputBlurHandler: tokenInputBlurHandler,
  } = useInput((value) => value.trim() !== "");

  let formIsValid = false;
  if (tokenInputIsValid) {
    formIsValid = true;
  }

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowSpinner(true);
    const data = {
      ...transaction,
      token: tokenInput,
    };

    const res = await createTransaction(jwt, data);

    if (res.status === "success") {
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
      navigate("/account/print-local-receipt");
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }
    setShowSpinner(false);
    setTimeout(() => {
      dispatch(alertActions.resetState());
    }, 3000);
  };

  const tokenInputClasses = tokenInputIsInvalid
    ? `${cf.field} ${cf.invalid}`
    : cf.field;

  return (
    <div className={cf.stack}>
      <div className={cf.pageTitleRow}>
        <HiOutlineClipboardDocumentCheck
          className={cf.pageTitleIcon}
          aria-hidden
        />
        <h2 className={cf.pageTitle}>Review and confirm</h2>
      </div>
      <div className={cf.summaryRow}>
        <span>Transfer type</span>
        <span>{transaction?.kind}</span>
      </div>
      <div className={cf.summaryRow}>
        <span>Bank name</span>
        <span>{transaction?.bankName}</span>
      </div>
      <div className={cf.summaryRow}>
        <span>Beneficiary name</span>
        <span>{transaction?.receipientName}</span>
      </div>
      <div className={cf.summaryRow}>
        <span>Beneficiary account number</span>
        <span>{transaction?.receipient}</span>
      </div>
      <div className={cf.summaryRow}>
        <span>Amount</span>
        <span>{currencySymbol}{formatCurrency(transaction?.amount)}</span>
      </div>
      <form
        className={`${cf.form} ${cf.formInStack}`}
        onSubmit={submitHandler}
      >
        {showSpinner && <Spinner />}
        <div className={cf.formTitleRow}>
          <HiOutlineShieldCheck className={cf.formTitleIcon} aria-hidden />
          <h2 className={cf.formTitle}>Transfer token</h2>
        </div>
        <p className={cf.formSubtitle}>
          Enter the 6-digit code sent to your email to authorise this payment.
        </p>
        <div className={tokenInputClasses}>
          <label htmlFor="confirm-local-token">Token</label>
          <div className={cf.inputGroup}>
            <FcDepartment className={cf.icon} />
            <input
              id="confirm-local-token"
              type="number"
              inputMode="numeric"
              value={tokenInput}
              onChange={tokenInputChangedHandler}
              onBlur={tokenInputBlurHandler}
            />
          </div>
        </div>
        <div className={cf.actions}>
          <button type="submit" disabled={!formIsValid}>
            <HiCheck className={cf.btnIcon} aria-hidden />
            Confirm payment
          </button>
        </div>
      </form>
    </div>
  );
};

export default ConfirmLocal;
